export const SET_CURRENTPESQUISA = 'CLIENT/SET_CURRENTPESQUISA';